import { useContext } from 'react';

import { infoSessionCancelledAtom } from 'atoms/inviteSession';
import { useAtomValue } from 'jotai';

import { DrawerInviteScheduleContext } from 'components/DrawerInviteSchedule/context/DrawerInviteScheduleContext';

import ConfirmInvite from '../ConfirmInvite';
import ConfirmInviteRescheduled from '../ConfirmInviteRescheduled';
import CreateInvite from '../CreateInvite';

const Body: React.FC = () => {
  const infoSessionCancelled = useAtomValue(infoSessionCancelledAtom);
  const { date, hour, patient, step } = useContext(DrawerInviteScheduleContext);

  if (step === 1) {
    return <CreateInvite />;
  }

  if (date && hour && infoSessionCancelled) {
    return <ConfirmInviteRescheduled />;
  }

  if (date && hour && patient) {
    return <ConfirmInvite />;
  }

  return null;
};

export default Body;
